<div class="w-full profile-container" *ngIf="!initialLoading">
    <div class="flex  flex-nowrap w-full p-3 gap-3 ">
        <p-toast />
        <div class="h-full relative">
            <p-card header="" class="flex h-[89vh]">
                <div class="flex space-x-2">
                    <!-- <img class="avatar-url" src="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png"
                    size="large" /> -->
                    <div style="display: flex; align-items: center;">
                        <p-avatar class="mr-2" size="xlarge" shape="circle"
                            [image]="previewImage || admissionDetails.profile_pic"
                            *ngIf="admissionDetails.profile_pic || previewImage; else showInitials" [style]="{
                            width: '60px',
                            height: '60px',
                            borderRadius: '50%',
                            cursor: 'pointer'
                          }" (click)="uploadInput.click()"></p-avatar>

                        <ng-template #showInitials>
                            <p-avatar class="mr-2" size="xlarge" shape="circle" label="{{ getInitials() }}" [style]="{
                              width: '60px',
                              height: '60px',
                              borderRadius: '50%',
                              fontSize: '30px',
                              cursor: 'pointer'
                            }" (click)="uploadInput.click()"></p-avatar>
                        </ng-template>

                        <input #uploadInput type="file" accept="image/*" (change)="onProfileImageUpload($event)"
                            style="display: none;" />
                    </div>



                    <div class="flex flex-col gap-3 justify-center">
                        <div class="flex flex-col gap-1">
                            <div class="text-[20px] font-bold ">
                                {{
                                getFullName()
                                }}
                            </div>
                            <div class="text-[13px]">
                                Admission No: {{admissionDetails.admission_number}}
                            </div>
                        </div>

                    </div>
                </div>

                <div class="flex items-center gap-2 mt-4 ml-2 max-w-[300px]">
                    <div class="text-[13px] break-all">
                        {{ admissionDetails.email }}
                    </div>
                    <div>
                        <i class="pi pi-clone cursor-pointer" (click)="handleCopy()"></i>
                    </div>
                </div>


                <div class="mt-5 flex gap-3">
                    <!-- note email task meeting call -->
                    <div class="flex flex-col items-center action-box gap-2">
                        <div class="action-icon" (click)="handleOpenNoteDialog()">
                            <i class="pi pi-clipboard"></i>
                        </div>
                        <div class="text-[13px] cursor-pointer" (click)="handleOpenNoteDialog()">
                            Notes
                        </div>
                    </div>
                    <div class="flex flex-col items-center action-box gap-2">
                        <div class="action-icon" (click)="handleOpenEmailLead()">
                            <i class="pi pi-envelope"></i>
                        </div>
                        <div class="text-[13px] cursor-pointer" (click)="handleOpenEmailLead()">
                            Email
                        </div>
                    </div>
                    <div class="flex flex-col items-center action-box gap-2">
                        <div class="action-icon" (click)="handleOpenTaskDialog()">
                            <i class="pi pi-list-check"></i>
                        </div>
                        <div class="text-[13px] cursor-pointer" (click)="handleOpenTaskDialog()">
                            Task
                        </div>
                    </div>
                    <div class="flex flex-col items-center action-box gap-2">
                        <div class="action-icon" (click)="handleOpenMeetingDialog()">
                            <i class="pi pi-calendar"></i>
                        </div>
                        <div class="text-[13px] cursor-pointer" (click)="handleOpenMeetingDialog()">
                            Meeting
                        </div>
                    </div>
                    <div class="flex flex-col items-center action-box gap-2">
                        <div class="action-icon" (click)="handleOpenCallLead()">
                            <i class="pi pi-phone"></i>
                        </div>
                        <div class="text-[13px] cursor-pointer" (click)="handleOpenCallLead()">
                            Call
                        </div>
                    </div>
                    <!-- <div class="flex flex-col items-center action-box gap-2">
                    <div class="action-icon">
                        <i class="pi pi-ellipsis-h"></i>
                    </div>
                    <div class="text-[13px]">
                        More
                    </div>
                </div> -->
                </div>

                <p-divider class="mt-2" class="divider"></p-divider>

                <h3 class="text-[20px] -mt-1 font-semibold">Quick Actions</h3>

                 <div class="flex flex-col gap-2 -mt-3">
                    <div class="mt-2">
                        <div class="mb-2 font-medium">Assigned To</div>
                        <p-select [options]="users" [(ngModel)]="selectedOwner"
                        appendTo="body"
                        placeholder="Select Assigned To"
                            class="w-full rounded-sm profile-select" />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Course</div>
                        <p-select [options]="fullCourseList"
                        optionLabel="name"
                        optionValue="course_id"
                        [(ngModel)]="selectedCourse" 
                        placeholder="Select Course"
                        appendTo="body"
                            class="w-full rounded-sm profile-select" />
                    </div>

                    <!-- Academic Year -->
                    <div class="mt-2">
                        <div class="mb-2 font-medium">Academic Year</div>
                        <p-select [options]="academicYearList" 
                        optionValue="id"
                        optionLabel="year_name"
                        [(ngModel)]="selectedAcademicYear"
                            appendTo="body"
                            placeholder="Select Academic Year" class="w-full rounded-sm profile-select" />
                    </div>

                    <!-- Admission Status -->
                    <div class="mt-2">
                        <div class="mb-2 font-medium">Admission Status</div>
                        <p-select [options]="admissionStatusList" [(ngModel)]="selectedAdmissionStatus"
                            appendTo="body"
                            placeholder="Select Admission Status" class="w-full rounded-sm profile-select" />
                    </div>

                    <!-- Batch-->
                    <div class="mt-2">
                        <div class="mb-2 font-medium">Batch</div>
                        <p-select [options]="batchList" [(ngModel)]="selectedBatch"
                            appendTo="body"
                            optionLabel="batch_name"
                            optionValue="id"
                            placeholder="Select Batch" class="w-full rounded-sm profile-select" />
                    </div>

                    <!-- Fee Category -->
                    <div class="mt-2 mb-16">
                        <div class="mb-2 font-medium">Fee Category</div>
                        <p-select [options]="feeCategoryList" [(ngModel)]="selectedFeeCategory"
                        optionLabel="group_name"
                        optionValue="id"
                        appendTo="body"
                            placeholder="Select Fee Category" class="w-full rounded-sm profile-select" />
                    </div>

                </div>

                <div class="mt-8 flex items-center gap-2 absolute  bottom-buttons">
                    <p-button label="Back" icon="pi pi-arrow-left" (onClick)="handleBack()" severity="secondary" />
                    <p-button label="Save" class="w-full" [loading]="loading" (onClick)="handleSaveQuickActions()"
                        [disabled]="loading" />

                </div>

            </p-card>
        </div>

        <div class="w-full">
            <p-card class="flex h-[89vh]">
                <app-admission-profile-middle-screen [selectedTabIdx]="selectedTabIdx" [users]="users" [editType]="editType"
                    [allCourses]="allCourses"
                    [fullUserList]="fullUserList"
                    [paymentForList]="paymentForList"
                    [fullCourseList]="fullCourseList"
                    [academicYearList]="academicYearList"
                    [batchList]="batchList"
                    [feeCategoryList]="feeCategoryList"
                    [departmentList]="departmentList"
                    [admissionStatusList]="admissionStatusList"
                    [allLeadFeilds]="allLeadFeilds" [editAdmissionData]="admissionDetails"
                    [transportRouteList]="transportRouteList"
                    [hostelList]="hostelCategoryList"
                    [scholarshipList]="scholarshipTypeList"
                    (handleUpdateData)="updateData($event)"
                    (changeTab)="handleTabChange($event)"></app-admission-profile-middle-screen>
            </p-card>
        </div>

        <div class="min-w-[350px] w-full">
            <p-card class="flex h-[89vh] min-w-[350px] w-full">
                <div  class="w-full">
                    <app-lead-timeline [timelineData]="leadActivity"></app-lead-timeline>
                </div>
            </p-card>
        </div>
    </div>
</div>

<div *ngIf="initialLoading" class="h-[80vh] flex items-center justify-center w-screen">
    <p-progress-spinner ariaLabel="loading" [style]="{ width: '100px', height: '100px' }" strokeWidth="2" />
</div>


<p-dialog [modal]="true" [(visible)]="isAddNote" [breakpoints]="{ '1199px': '55vw', '575px': '90vw' }" closable="false"
    [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <app-add-note 
    [lead_id]="lead_id"
    (closeDialog)="handleCloseNoteDialog()"></app-add-note>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isEmailLead" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <app-lead-email 
    (closeDialog)="handleCloseEmailDialog()" [communicationData]="admissionDetails"></app-lead-email>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isAddTask" [breakpoints]="{ '1199px': '55vw', '575px': '90vw' }" closable="false"
    [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <app-lead-task 
    [currentLeadId]="lead_id"
    (closeDialog)="handleCloseTaskDialog()"></app-lead-task>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isAddMeeting" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <app-lead-meeting [leadDetails]="admissionDetails" (closeDialog)="handleCloseMeetingDialog()"></app-lead-meeting>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isCallLead" [breakpoints]="{ '1199px': '50vw', '575px': '90vw', }"
    closable="false" [style]="{ width: '35vw' }" [draggable]="false" [resizable]="false">
    <app-lead-call (closeDialog)="handleCloseCallDialog()" [communicationData]="admissionDetails"></app-lead-call>
</p-dialog>